import React from 'react';
import {useWindowDimensions} from 'react-native';
import {noop} from 'lodash';

import TabLayout from '/component/layout/TabLayout';
import ReportDefaultLoading from '/component/partial/report/ReportDefaultLoading';

import {EmptyView} from './EmptyView';
import {useClientToContact} from './PeopleToContact.hook';
import {styles} from './PeopleToContact.style';
interface FeatureFlags {
  showClientJourney: boolean;
  showActive: boolean;
  CC_SR: boolean;
  showRX: boolean;
}
interface PageMeta {
  page: {
    total: number;
  };
}
interface PeopleToContactProps {
  onShowReport: () => void;
  onShowProfile: () => void;
  getClientToContact: () => void;
  hasNoOrder: boolean;
  hasExpiringRewards: boolean;
  hasRecentlyInactive: boolean;
  hasPremierCancellations: boolean;
  hasExpiringWellnessCredits: boolean;
  hasNextTask: boolean;
  hasNoActiveOrder: boolean;
  hasNoRXOrder: boolean;
  hasNewCandidate: boolean;
  parentScreenName: string;
  fetchReport: () => void;
  showFullReport: boolean;
  reportDefaultLoadingCount: number;
  initialRouteName: any;
  swipeEnabled: boolean;
  noOrderIsLoading: boolean;
  expiringRewardsIsLoading: boolean;
  recentlyInactiveIsLoading: boolean;
  premierCancellationsIsLoading: boolean;
  expiringWellnessCreditsIsLoading: boolean;
  nextTaskIsLoading: boolean;
  noActiveOrderIsLoading: boolean;
  noRXOrderIsLoading: boolean;
  newCanadidateIsLoading: boolean;
  noOrderMeta: PageMeta;
  expiringRewardsMeta: PageMeta;
  recentlyInactiveMeta: PageMeta;
  premierCancellationsMeta: PageMeta;
  expiringWellnessCreditsMeta: PageMeta;
  nextTaskMeta: PageMeta;
  noActiveOrderMeta: PageMeta;
  noRXOrderMeta: PageMeta;
  newCandidateMeta: PageMeta;
  isEmptyNoOrder: boolean;
  isEmptyPremierCancellations: boolean;
  isEmptyRecentlyInactive: boolean;
  isEmptyExpiringWellnessCredits: boolean;
  isEmptyExpiringRewards: boolean;
  isEmptyNextTask: boolean;
  isEmptyNoActiveOrder: boolean;
  isEmptyNoRXOrder: boolean;
  isEmptyNewCandidate: boolean;
  isAlertsLoading: boolean;
  featureFlag: FeatureFlags;
  isClientJourneyLoading: boolean;
  lastPaidRank: number;
  highestRankDescription: string;
  userId: string;
}

export const PeopleToContact: React.FC<PeopleToContactProps> = ({
  onShowReport = noop,
  onShowProfile = noop,
  getClientToContact = noop,
  hasNoOrder = false,
  hasRecentlyInactive = false,
  hasPremierCancellations = false,
  hasExpiringWellnessCredits = false,
  hasNextTask = false,
  hasNoActiveOrder = false,
  hasNoRXOrder = false,
  hasNewCandidate = false,
  parentScreenName = '',
  fetchReport = noop,
  showFullReport = false,
  reportDefaultLoadingCount = 3,
  initialRouteName = null,
  swipeEnabled = false,
  noOrderIsLoading = false,
  expiringRewardsIsLoading = false,
  recentlyInactiveIsLoading = false,
  premierCancellationsIsLoading = false,
  expiringWellnessCreditsIsLoading = false,
  nextTaskIsLoading = false,
  noActiveOrderIsLoading = false,
  noRXOrderIsLoading = false,
  newCanadidateIsLoading = false,
  noOrderMeta = {page: {total: 0}},
  expiringRewardsMeta = {page: {total: 0}},
  recentlyInactiveMeta = {page: {total: 0}},
  premierCancellationsMeta = {page: {total: 0}},
  expiringWellnessCreditsMeta = {page: {total: 0}},
  nextTaskMeta = {page: {total: 0}},
  noActiveOrderMeta = {page: {total: 0}},
  noRXOrderMeta = {page: {total: 0}},
  newCandidateMeta = {page: {total: 0}},
  isEmptyNoOrder = false,
  isEmptyPremierCancellations = false,
  isEmptyRecentlyInactive = false,
  isEmptyExpiringWellnessCredits = false,
  isEmptyNextTask = false,
  isEmptyNoActiveOrder = false,
  isEmptyNoRXOrder = false,
  isEmptyNewCandidate = false,
  isAlertsLoading = false,
  featureFlag = {
    showClientJourney: false,
    showActive: false,
    CC_SR: false,
    showRX: false,
  },
  isClientJourneyLoading = false,
  lastPaidRank,
  highestRankDescription,
  userId,
}) => {
  const {width: screenWidth} = useWindowDimensions();

  const {tabs, currentLOADEDRouteName} = useClientToContact({
    featureFlag,
    onShowReport,
    onShowProfile,
    getClientToContact,
    isEmptyNoOrder,
    isEmptyPremierCancellations,
    isEmptyRecentlyInactive,
    isEmptyExpiringWellnessCredits,
    // isEmptyExpiringRewards,
    isEmptyNextTask,
    isEmptyNoActiveOrder,
    isEmptyNoRXOrder,
    isEmptyNewCandidate,
    hasNoOrder,
    // hasExpiringRewards,
    hasRecentlyInactive,
    hasPremierCancellations,
    hasExpiringWellnessCredits,
    hasNextTask,
    hasNoActiveOrder,
    hasNoRXOrder,
    hasNewCandidate,
    parentScreenName,
    showFullReport,
    fetchReport,
    initialRouteName,
    noOrderIsLoading,
    expiringRewardsIsLoading,
    recentlyInactiveIsLoading,
    premierCancellationsIsLoading,
    expiringWellnessCreditsIsLoading,
    nextTaskIsLoading,
    noActiveOrderIsLoading,
    noRXOrderIsLoading,
    newCanadidateIsLoading,
    noOrderMeta,
    expiringRewardsMeta,
    recentlyInactiveMeta,
    premierCancellationsMeta,
    expiringWellnessCreditsMeta,
    nextTaskMeta,
    noActiveOrderMeta,
    noRXOrderMeta,
    newCandidateMeta,
    isAlertsLoading,
    isClientJourneyLoading,
    lastPaidRank,
    highestRankDescription,
    userId,
  });

  // Enable swipe gestures only when tabs likely overflow the visible width.
  const shouldEnableDynamicSwipe =
    tabs.reduce((totalWidth, tab) => {
      const labelLength = String(tab?.label || tab?.name || '').length;
      const estimatedTabWidth = Math.max(88, labelLength * 7 + 32);
      return totalWidth + estimatedTabWidth;
    }, 0) > Math.max(320, screenWidth - 32);

  const isSwipeEnabled = swipeEnabled || shouldEnableDynamicSwipe;

  // We use isAlertsLoading variable to avoid displaying incorrect content while
  // alerts and reports are updated after cancellation on the Client Profile page.
  if (
    !hasNewCandidate ||
    !hasNoOrder ||
    // !hasExpiringRewards ||
    !hasRecentlyInactive ||
    !hasPremierCancellations ||
    !hasExpiringWellnessCredits ||
    (!hasNextTask && featureFlag.showClientJourney) ||
    (!hasNoActiveOrder && featureFlag.showActive) ||
    (!hasNoRXOrder && featureFlag.showRX) ||
    isAlertsLoading
  ) {
    return <ReportDefaultLoading total={reportDefaultLoadingCount} />;
  }

  if (
    isEmptyNewCandidate &&
    isEmptyNoOrder &&
    isEmptyPremierCancellations &&
    isEmptyRecentlyInactive &&
    isEmptyExpiringWellnessCredits &&
    // isEmptyExpiringRewards &&
    isEmptyNextTask &&
    isEmptyNoActiveOrder &&
    isEmptyNoRXOrder
  ) {
    return <EmptyView />;
  }

  return (
    <TabLayout
      initialRouteName={currentLOADEDRouteName}
      screenOptions={{
        tabBarScrollEnabled: true,
        tabBarBounces: false,
        swipeEnabled: isSwipeEnabled,
        lazyPlaceholder: () => <ReportDefaultLoading total={1} />,
        lazy: true,
      }}
      tabs={tabs}
      style={{
        sceneContainerStyle: styles.sceneContainerStyle,
        tabBarStyle: styles.tabBarStyle,
        tabBarItemStyle: styles.tabBarItemStyle,
        tabBarIndicatorContainerStyle: styles.tabBarIndicatorContainerStyle,
      }}
      isPeopleToContact
    />
  );
};
